export default __webpack_public_path__ + "static/media/Icon awesome-chart-bar.65c958e8.svg";